/**
 * FreeSpins Class
 *
 * this module manages both freespins modes it inherits from spin functions
 *
 */

freespins = (function () {
  var _inFreeSpins = false;
  var _stopOffsets;
  var _currentMsgBox;
  var _msgBoxFinalPos = {};
  var _msgBoxStartPos = { x: 0, y: -500 };
  var _msgBoxIntroCallback;
  var _msgBoxOutroCallback;
  var _awardFreespinsTask;
  var _endFreespinsTask;

  var _initialDroppingFS = 0;
  var _bonusAnimsPlayed = false;

  var _freeSpinsMeter;
  let _gambleSpin;

  function initialise() {
    _gambleIntro = resourceManager.get("gambleIntroContainer:GambleIntro");
    _gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");
    _freeSpinsMeter = resourceManager.get("freeSpinsMeter");
    _spinButton = resourceManager.get("buttonContainer:buttonBar:spinButton");
    _fairyMultiplierView = resourceManager.get(
      "fairyMultiplierContainer:FairyMultiplierView"
    );
    _frogView = resourceManager.get("frogContainer:FrogView");
  }

  function canEnableSpin() {
    return freespins.stateMachine.ActiveStateName === "READY_TO_START";
  }

  function canShowSpin() {
    return freespins.stateMachine.ActiveStateName === "READY_TO_START";
  }

  function canEnableSkip() {
    return freespins.stateMachine.ActiveStateName === "PAYWINS";
  }

  function canShowSkip() {
    return freespins.stateMachine.ActiveStateName === "PAYWINS";
  }

  // this just flips the layout between freeSpins and normal
  function freespinsMode(bool) {
    _inFreeSpins = bool;
  }

  function awardFreeSpinsComplete() {
    //slotMachine.selectReelMode("freespins");
    _awardFreespinsTask.leave();
  }

  function onDecisionMade(task, resultCallback, gambleDecision) {
    if (gambleDecision === "collect") {
      resultCallback({ response: "collect" }, function () {
        task.leave();
      });
    } else {
      resultCallback({ response: "gamble" }, function () {
        task.leave();
      });
    }

    gameController.cancelAutoplay();
  }

  function onFreespinsAwarded(task) {
    // animate the bonus symbols before bringing up the dialog
    let temp = task;
    temp.join();

    const callbacks = [];
    if (!gameController.inBuyABonus) {
      const bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
      if (!_bonusAnimsPlayed) {
        soundManager.play("bonusWon");
        for (var i = 0; i < reelManager.reels.length; i++) {
          for (var j = 0; j < 3; j++) {
            if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
              gameData.reels[i].showSymbol(j, false);
              callbacks.push(
                AllWaysPayWinAnimator.animateSymbolWithoutBorder("Bonus", i, j)
              );
            }
          }
        }
      }
    }

    _bonusAnimsPlayed = true;

    const delay = gameController.inBuyABonus ? 500 : 2000;
    timerManager.addTimeout(delay, function () {
      showDialog(temp);
      if (!gameController.inBuyABonus) {
        timerManager.addTimeout(500, () => {
          callbacks.forEach((c) => c());
        });
      }
    });
  }

  function showDialog(task) {
    const temp = task;

    _fairyMultiplierView.resetMultiplier();

    if (task.data.numScatters === 5 || !gdk.getPlatformAllowsGamble()) {
      // auto collect max bonus
      onDecisionMade(temp, temp.data.resultCallback, "collect");

      hideReel();

      return;
    }

    // mid gamble
    if (_gambleSpin.visible) {
      _gambleIntro.reactivate(
        task.data.numFreeSpins,
        task.data.x3WinChance,
        task.data.x4WinChance,
        onDecisionMade.bind(this, temp, temp.data.resultCallback)
      );
    } else {
      // resets free spins index - base on scatters won
      // 3 scatters start at 0
      // 4 scatter - 1
      // 5 scatters - shouldn't gamble
      _gambleSpin.resetGambleSpin(task.data.numScatters - 3);

      let initialDelay = 0;
      timerManager.addTimeout(initialDelay, function () {
        _gambleIntro.start(
          task.data.numFreeSpins,
          task.data.x3WinChance,
          task.data.x4WinChance,
          task.data.possibleValues,
          task.data.numScatters - 3,
          function () {
            setupFsScene(task.data.numFreeSpins);
          },
          onDecisionMade.bind(this, temp, temp.data.resultCallback)
        );
      });
    }
  }

  function hideReel() {
    let reels = resourceManager.get("slotContainer:reelContainer");

    var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
    let animStrips = [];

    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      var animStrip = resourceManager.get(
        reelManager.reels[reelID].linkedAnimations[0].name
      );
      animStrips.push(animStrip);
    }

    timerManager.addTimer(
      300,
      function (progress) {
        animStrips.forEach((strip) => {
          strip.alpha = 1 - progress;
        });

        reels.alpha = 1.0 - progress;
      },
      function () {
        reels.alpha = 0;

        animStrips.forEach((strip) => {
          strip.hideAllAnimations();
        });

        for (var i = 0; i < reelManager.reels.length; i++) {
          for (var j = 0; j < 3; j++) {
            if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
              gameData.reels[i].showSymbol(j, true);
            }
          }
        }
      }
    );
  }

  function onFreespinsStart(task) {
    let temp = task;
    temp.join();

    gameController.cancelAutoplay();

    _gambleSpin.visible = false;

    _freeSpinsMeter.resetMeter();
    _freeSpinsMeter.addSpins(task.data.freeSpinsAwarded);

    _gambleIntro.doShowIntro(task.data.freeSpinsAwarded, function () {
      // resourceManager.get("jackpotsView:JackpotsContainer").updatePots();

      const reels = resourceManager.get("slotContainer:reelContainer");
      const fsBg = resourceManager.getContainer("fsBackgroundContainer");
      const goldenBetButton = resourceManager.get(
        "buttonContainer:buttonBar:luckyBetToggleButton"
      );
      const gambleModeButton = resourceManager.get(
        "buttonContainer:buttonBar:gambleModeButton:button"
      );
      const buyBonusButton = resourceManager.get(
        "buttonContainer:buttonBar:buyBonusButton"
      );

      resourceManager.get("leavesContainer:LeavesView").onFreeSpinsStart();

      fsBg.alpha = 0;
      fsBg.visible = true;
      const frogAnim = _frogView.getFrogAnim();
      frogAnim.alpha = 0;
      frogAnim.visible = true;
      gsap.fromTo(
        [reels, fsBg, frogAnim],
        { alpha: 0 },
        {
          alpha: 1,
          duration: 0.3,
          onComplete: () => {
            _frogView.playFrogStartAnim();
          },
        }
      );
      gsap.fromTo(
        [goldenBetButton, gambleModeButton, buyBonusButton],
        { alpha: 1 },
        { alpha: 0, duration: 0.3 }
      );
      temp.leave();
      temp = undefined;
    });
  }

  function onFreespinsStartDead(task) {
    _winnings = 0;

    freespinsMode(true);
    hideSpinButton();
    startSpins();
  }

  function startSpins() {
    startGame();

    gdk.getNextGameOutcome(function () {});
  }

  function startGame() {
    gameController.resetWinnings();

    gameData.numPops = 0;

    freespins.spinTask = undefined;

    _freeSpinsMeter.useSpin();

    freespins.stateMachine.switchState("CLEAR_REELS");

    _fairyMultiplierView.playFairyStartAnim();

    _frogView.playFrogStartAnim();
  }

  function hideSpinButton() {
    gameData.inputOverlord.setState("freespinsEnabled");
  }

  function onFreespinsAwardedEnd() {
    showSpinButton();
    gdk.getNextGameOutcome(function () {});
  }

  function showSpinButton() {
    _spinButton.visible = true;
  }

  function onMultiplierEvent(task) {
    if (task.data.nextMultiplier === -1 && task.data.currentStep > 1) {
      return;
    }

    freespins.MultiplierTask = task;
  }

  function setupFsScene(numFs) {
    hideReel();
  }

  function onFreespinsDataEvent(task) {
    let delay = 0;
    if (slotMachine.slamStopRequested) {
      delay = 0.33;
    }

    timerManager.addTimeout(delay, () => {
      _spinsRemaining = task.num;
      startGame();
      gdk.getNextGameOutcome(function () {});
    });
  }

  function onGambleResultEvent(task) {
    let temp = task;
    temp.join();
    if (temp.data.localRng != null) {
      gameController.rng.seed(temp.data.localRng);
    }

    _gambleSpin.spinToResult(task.data.won, function () {
      temp.leave();
      temp = undefined;
    });
  }

  function onGambleResultEventDead(task) {
    if (!task.won) {
      _bonusAnimsPlayed = false;

      musicManager.onFreespinsLostGambleEnd();
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;
    }
  }

  function onFreespinsEndEvent(task) {
    _endFreespinsTask = task;
    _endFreespinsTask.join();

    _bonusAnimsPlayed = false;

    const freeSpinsWin = _endFreespinsTask.data.finalFsWinnings;

    // Put in a pause then show a big win or free spins end
    timerManager.addTimer(1000, undefined, function () {
      doFreeSpinsOutroDialog(freeSpinsWin);
    });
  }

  function doFreeSpinsOutroDialog(freeSpinsWin) {
    resourceManager.getContainer("freeSpinsContainer").visible = false;
    // Show outro
    _freeSpinsIntroOutro = resourceManager.get(
      "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
    );
    _freeSpinsIntroOutro.showOutro(freeSpinsWin, doBigWinCheck);

    // resourceManager
    //   .get("jackpotsView:JackpotsContainer")
    //   .updatePots(resourceManager.getController("stakeController").BaseStake);

    _frogView.playFrogFSEndAnim();
  }

  function doBigWinCheck() {
    const totalWinnings = _endFreespinsTask.data.totalWinnings;

    _bigWin = resourceManager.get("bigWin");
    const isBigWin = _bigWin.willTriggerBigWin(totalWinnings);

    let minWinRequired = 0;
    if (gameController.inBuyABonus) {
      minWinRequired = gameController.globalHelperGetStake(GLOBALS.BONUS_BUY);
    }

    if (totalWinnings > minWinRequired && isBigWin) {
      _bigWin.start(totalWinnings, endFreespins);
    } else {
      endFreespins();
    }
  }

  function endFreespins() {
    const fsBg = resourceManager.getContainer("fsBackgroundContainer");
    const goldenBetButton = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );
    const gambleModeButton = resourceManager.get(
      "buttonContainer:buttonBar:gambleModeButton:button"
    );
    const buyBonusButton = resourceManager.get(
      "buttonContainer:buttonBar:buyBonusButton"
    );

    resourceManager.get("leavesContainer:LeavesView").onFreeSpinsEnd();

    const frogAnim = _frogView.getFrogAnim();
    gsap.fromTo(
      [fsBg, frogAnim],
      { alpha: 1 },
      {
        alpha: 0,
        duration: 0.3,
        delay: 0.5,
        onComplete: () => {
          fsBg.visible = false;
          frogAnim.stop();
          frogAnim.visible = false;
        },
      }
    );
    gsap.fromTo(
      [goldenBetButton, gambleModeButton, buyBonusButton],
      { alpha: 0 },
      {
        alpha: 1,
        duration: 0.3,
        delay: 0.5,
      }
    );

    freespinsMode(false);
    gameData.inputOverlord.setState("enabled");

    freespins.stateMachine.switchState("READY_TO_START");
    musicManager.wasInFreeSpins = true;
    musicManager.onFreespinsEnd();
    _endFreespinsTask.leave();
  }

  ////////////////////////////////////////////
  // define freespins Object to be returned //
  ////////////////////////////////////////////

  freespins = Object.create(spinFunctions);

  Object.defineProperties(freespins, {
    initialise: {
      value: initialise,
    },
    freespinsMode: {
      value: freespinsMode,
    },
    inFreespins: {
      get: function () {
        return _inFreeSpins;
      },
    },
    onFreespinsAwarded: {
      value: onFreespinsAwarded,
    },
    onFreespinsAwardedEnd: {
      value: onFreespinsAwardedEnd,
    },
    onFreespinsStart: {
      value: onFreespinsStart,
    },
    onFreespinsStartDead: {
      value: onFreespinsStartDead,
    },
    onFreespinsDataEvent: {
      value: onFreespinsDataEvent,
    },
    onFreespinsEndEvent: {
      value: onFreespinsEndEvent,
    },
    onGambleResultEvent: {
      value: onGambleResultEvent,
    },
    onGambleResultEventDead: {
      value: onGambleResultEventDead,
    },
    canEnableSpin: {
      value: canEnableSpin,
    },
    canShowSkip: {
      value: canShowSkip,
    },
    canEnableSkip: {
      value: canEnableSkip,
    },
    canShowSpin: {
      value: canShowSpin,
    },
    startGame: {
      value: startGame,
    },
  });

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(freespins);

  ///
  freespins.stateMachine.addState("WAITING_FOR_SERVER", function () {});

  ///
  freespins.stateMachine.addState("READY_TO_START", function () {});

  ///
  freespins.initialDropComplete = function (reelID) {
    --_initialDroppingFS;
  };

  freespins.areFreeSpinsActive = function () {
    return freespins._inFreeSpins;
  };

  ///
  freespins.stateMachine.addState("CLEAR_REELS", function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count

    if (freespins.phase.enter()) {
      _minGameTimePassed = true;

      const license = gameData.license.toUpperCase();
      if (license === 'DE') {
        _minGameTimePassed = false;
        timerManager.addTimeout(gdk.minGameTime * 1000, () => {
          _minGameTimePassed = true;
        })
      }
    }

    // ensure we have result data before proceeding - don't clear reels until this is set
    if (freespins.phase.hold()) {
      if (freespins.spinTask !== undefined) {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      slotMachine.clearReels();

      _initialDroppingFS = gameData.reels.length;
      gameController.resetSymbolCallbackFired();
    }

    if (freespins.phase.hold()) {
      if (_initialDroppingFS === 0) {
        let _positions = freespins.spinTask.data.resultPanel.reelList.map(
          function (reel, index) {
            return reel.symbols.map(function (curr) {
              return curr.value;
            });
          }
        );

        // we need to have a random symbol as the first below which we can drop
        // off the symbol grid when new symbols all cascade in
        // NOTE:  Freespins can't retrigger so make sure no feature symbols are selected
        // Also wild symbols shouldn't be shown so limit to first 8
        let randomBelow = [];
        for (var i = 0; i < gameData.reels.length; i++) {
          randomBelow[i] = getRandom(8);
        }

        let _symbolsAbove = [[0], [0], [0], [0], [0]];
        let _symbolsBelow = [
          [randomBelow[0]],
          [randomBelow[1]],
          [randomBelow[2]],
          [randomBelow[3]],
          [randomBelow[4]],
        ];

        // calculate whether we display landing symbols - this should be empty for free spins
        gameController.calcLandingAnims();

        slotMachine.dropInitialSymbols(
          _symbolsAbove,
          _positions,
          _symbolsBelow,
          null,
          gameController.spinTask.data.cashPotData
        );
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      freespins.stateMachine.switchState("REELS_SPINNING");
    }
  });

  freespins.onSpinCompleteFS = function (reelID) {
    freespins.reelsSpinning[reelID] = false;
  };

  freespins.stateMachine.addState("REELS_SPINNING", function () {
    if (freespins.phase.enter()) {
      gameController._receivedResponse = true; // this allows slam stop
      freespins.reelsSpinning = [true, true, true, true, true];
    }

    // don't proceed until all reels have finished spinning
    if (freespins.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (
        var spinningIdx = 0;
        spinningIdx < freespins.reelsSpinning.length;
        spinningIdx++
      ) {
        spinComplete = spinComplete && !freespins.reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        freespins.phase.step();
        gameController._receivedResponse = false;
      }
    }

    if (freespins.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");
    }

    if (freespins.phase.hold()) {
      const license = gameData.license.toUpperCase();
      if (license === 'DE') {
        if ((freespins.spinTask?.data?.totalWinnings ?? 0) > 0) {
          _minGameTimePassed = true;
        }
        if (_minGameTimePassed) {
          freespins.phase.step();
        }
      } else {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      if (freespins.spinTask) {
        freespins.spinTask.leave();
      }
    }
  });

  freespins.stateMachine.addState("PAYWINS", function () {});

  freespins.stateMachine.addState("PAY_TO_WINNINGS", function () {
    if (freespins.phase.enter()) {
      gameData.winningsMeter.countUp(
        freespins.winsTask.data.totalLineWinnings,
        1000
      );
    }
    if (freespins.phase.hold()) {
      if (!gameData.winningsMeter.Props.isCounting) {
        freespins.winsTask.leave();
      }
    }
  });

  function update(delta) {
    _delta = delta;
    this.stateMachine.update();
  }

  messageBus.subscribe("game:MultiplierEvent", onMultiplierEvent);
  messageBus.subscribe("game:FreeSpinsAwardEvent", onFreespinsAwarded);
  messageBus.subscribe("game:FreeSpinsAwardEventDead", onFreespinsAwardedEnd);
  messageBus.subscribe("game:FreeSpinsStartEvent", onFreespinsStart);
  messageBus.subscribe("game:FreeSpinsStartEventDead", onFreespinsStartDead);
  messageBus.subscribe("game:FreeSpinsDataEventDead", onFreespinsDataEvent);
  messageBus.subscribe("game:FreeSpinsEndEvent", onFreespinsEndEvent);
  messageBus.subscribe("fire_gems:GambleResultEvent", onGambleResultEvent);
  messageBus.subscribe(
    "fire_gems:GambleResultEventDead",
    onGambleResultEventDead
  );
  Reflex.addToUpdate(update.bind(freespins));

  return freespins;
})();
